import React from 'react';

import LoginComponent from '../components/LoginComponent/LoginComponent';
import { useLogin } from '../hooks/useLogin';
import DefaultLayout from '../layout/DefaultLayout';
import { isSaas } from '../utils';

const Login = () => {
    const { isLoading, handleLogin, handleLoginWithGoogle, handleLoginWithMicrosoft, handleLoginWithApple } =
        useLogin();

    return (
        <DefaultLayout>
            <LoginComponent
                isLoading={isLoading}
                handleLoginWithGoogle={handleLoginWithGoogle}
                handleLoginWithMicrosoft={handleLoginWithMicrosoft}
                handleLoginWithApple={handleLoginWithApple}
                handleLogin={handleLogin}
                isSaas={Boolean(isSaas)}
            />
        </DefaultLayout>
    );
};

export const MemoizeLogin = React.memo(Login);
